<template>
  <div class="tw-mb-4 tw-flex tw-flex-col tw-gap-3">
    <div>
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-bold">
        {{ appendColon($t("to"), locale) }}
      </div>
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-normal">
        {{ messageDetails.receiver }}
      </div>
    </div>
    <div class="">
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-bold">
        {{ appendColon($t("from"), locale) }}
      </div>
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-normal">
        {{ messageDetails.sender_name }}
      </div>
      <cl-badge :size="'sm'">
        <span>{{ messageDetails.sender_mail }}</span>
        <template v-if="messageDetails.sender_classified_as">
          <cl-badge-label>
            {{ messageDetails.sender_classified_as }}
          </cl-badge-label>
        </template>
      </cl-badge>
    </div>
    <div class="">
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-bold">
        {{ appendColon($t("date"), locale) }}
      </div>
      <div class="tw-mr-2 tw-inline-flex tw-text-base tw-font-normal">
        <span v-format-date="`MMM D, YYYY HH:mm`" v-if="messageDetails.sent_at">
          {{ messageDetails.sent_at }}
        </span>
        <span v-else> - </span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { IncidentDetailsMessage } from "@/modules/PhishTitan/types/IncidentSummary";
import { appendColon } from "@/utils/appendColon";

defineProps<{ messageDetails: IncidentDetailsMessage }>();
const { locale } = useI18n();
</script>
